import { useOutletContext } from "react-router";
import useUpdateUserPayment from "./useUpdateUserPayment";
import { useState } from "react";
import {
  ModalContainer,
  Title,
  DetailsList,
  DetailRow,
  Label,
  Value,
  Select,
  UpdateButton,
} from "./UpdatePaymentModal.styles";
import { formatDate } from "../../../../services/Utils";
import { formatPaymentMethod } from "../../../sharable/PaymentsTable";
import Notification from "../../../sharable/Notification";

const STATUS_OPTIONS = [
  { value: "COMPLETED", label: "Pago" },
  { value: "PENDING", label: "Pendente" },
  { value: "CANCELED", label: "Cancelado" },
  { value: "REFUNDED", label: "Reembolsado" },
];

const PLAN_OPTIONS = [
  { value: "MONTHLY_BASIC_26", label: "Plano mensal básico" },
  { value: "MONTHLY_PREMIUM_26", label: "Plano mensal premium" },
  { value: "TRIMESTER_PREMIUM_26", label: "Plano trimestral premium" },
  { value: "SEMESTER_PREMIUM_26", label: "Plano semestral premium" },
  { value: "YEARLY_PREMIUM_26", label: "Plano anual premium" },
];

export default function UpdatePaymentModal({ payment, onClose }) {
  const { user, token } = useOutletContext();
  const [status, setStatus] = useState(payment.status);
  const [plan, setPlan] = useState(payment.subscriptionPlan);
  const { update, notification, loading } = useUpdateUserPayment(
    token,
    payment,
  );

  const handleUpdate = async () => {
    await update(payment.id, { status, subscriptionPlan: plan });
    if (onClose) onClose();
  };

  if (!payment) return null;
  return (
    <ModalContainer>
      {notification && (
        <Notification
          message={notification.message}
          type={notification.type}
          autoHide={true}
        />
      )}
      <Title>Detalhes do Pagamento</Title>
      <DetailsList>
        <DetailRow>
          <Label>Plano:</Label>
          <Select value={plan} onChange={(e) => setPlan(e.target.value)}>
            {PLAN_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </Select>
        </DetailRow>
        <DetailRow>
          <Label>Status:</Label>
          <Select value={status} onChange={(e) => setStatus(e.target.value)}>
            {STATUS_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </Select>
        </DetailRow>
        <DetailRow>
          <Label>Data:</Label>
          <Value>{formatDate(payment.createdAt)}</Value>
        </DetailRow>
        <DetailRow>
          <Label>Método:</Label>
          <Value>{formatPaymentMethod(payment.paymentMethod)}</Value>
        </DetailRow>
        <DetailRow>
          <Label>ID:</Label>
          <Value>{payment.id}</Value>
        </DetailRow>
      </DetailsList>

      <UpdateButton onClick={handleUpdate} disabled={loading}>
        {loading ? "Atualizando..." : "Atualizar"}
      </UpdateButton>
      {onClose && (
        <UpdateButton
          style={{ background: "#eee", color: "#222", marginLeft: 8 }}
          onClick={onClose}
        >
          Fechar
        </UpdateButton>
      )}
    </ModalContainer>
  );
}
